import { useState, useCallback } from 'react';

type ToggleFunction = {
  (): void;
  (value: boolean): void;
  (event: any): void; // For event handlers
};

// Hook
// Parameter is the boolean, with a default "false" value
function useToggle(initialState: boolean = false): [boolean, ToggleFunction] {
  // Initialize the state
  const [state, setState] = useState<boolean>(initialState);

  // Define and memorize toggler function in case we pass down the component,
  // This function changes the boolean value to its opposite value
  const toggle = useCallback<ToggleFunction>((valueOrEvent?: boolean | any) => {
    setState((currentState: boolean) => {
      // If it's a boolean value, use it directly
      if (typeof valueOrEvent === 'boolean') {
        return valueOrEvent;
      }

      // If it's an event or undefined, toggle the current state
      return !currentState;
    });
  }, []);

  return [state, toggle];
}

export default useToggle;
